import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

import { AuthProvider } from "./providers/auth-provider"
import { RouterProviderWithContext } from "./providers/router-provider"
import { router } from "./router"
import { configureCallerAuthFailureHandler } from "./lib/api"
import { createSessionExpiryHandler } from "./lib/session-expiry"
import { initializeTheme } from "./lib/theme"
import "./index.css"

initializeTheme()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

configureCallerAuthFailureHandler(
  createSessionExpiryHandler({
    queryClient,
    currentLocation: () => window.location,
    invalidateRouter: () => {
      void router.invalidate()
    },
    redirect: (location) => window.location.assign(location),
  })
)

const root = document.getElementById("root")
if (!root) {
  throw new Error("Missing #root element")
}

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProviderWithContext router={router} />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>
)
